/* Same-document navigation for customer-opened editors. Never stores photos. */
(function (global) {
  'use strict';
  if (global.GIOEditorHistory) return;
  var key = '__gioEditorHistory', page = 'gio-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  var bindings = new WeakMap(), entries = Object.create(null), sequence = 0, handling = false, pending = null, traversalTimer = 0;
  function state() { try { return global.history.state; } catch (_) { return null; } }
  function mark(value) { var item = value && value[key]; return item && item.page === page ? item : null; }
  function merged(value, marker) {
    var next = Object.assign({}, value && typeof value === 'object' ? value : {});
    if (marker) next[key] = marker; else delete next[key];
    return next;
  }
  function replace(marker, url) { global.history.replaceState(merged(state(), marker), '', url || global.location.href); }
  function visible(binding) { return !!(binding.modal && binding.modal.modal && binding.modal.modal.classList.contains('tingle-modal--visible')); }
  function retire(entry, fromBack) {
    if (!entry || !entry.active) return;
    entry.active = false;
    if (fromBack) {
      try { if (entry.cancel) entry.cancel(); } catch (_) {}
      try { if (entry.back) entry.back(); } catch (_) {}
    }
    entry.cancel = null; entry.back = null;
  }
  function drain() {
    if (handling || pending) return;
    var marker = mark(state()), entry = marker && entries[marker.id];
    if (!entry || entry.active) return;
    // Consume only a record we created and just closed. Forward navigation to
    // an old record is normalized separately, never redirected backwards.
    pending = { id: entry.id, parent: entry.parent, url: entry.root.url };
    try {
      global.history.back();
      traversalTimer = global.setTimeout(function () {
        if (!pending || pending.id !== entry.id) return;
        pending = null;
        var current = mark(state());
        if (current && current.id === entry.id) { try { replace(null); } catch (_) {} }
      }, 1500);
    }
    catch (_) { pending = null; try { replace(null); } catch (ignored) {} }
  }
  function release(entry) { retire(entry, false); drain(); }
  function create(parent, back, cancel) {
    if (pending) return null; // An in-flight traversal must not consume a new UI.
    var id = ++sequence, entry = { id:id, parent:parent ? parent.id : null, active:true, back:back, cancel:cancel, root:null };
    entry.root = parent ? parent.root : { url:global.location.href };
    try {
      global.history.pushState(merged(state(), { page:page, id:id }), '', global.location.href);
      entries[id] = entry;
      return entry;
    } catch (_) { return null; }
  }
  function ticket(entry) {
    return entry ? { isActive:function () { return entry.active; }, cancel:function () { release(entry); } } : null;
  }
  function reconcile(event) {
    var traversal = pending; pending = null;
    global.clearTimeout(traversalTimer); traversalTimer = 0;
    var marker = mark(event && event.state !== undefined ? event.state : state()), target = marker && entries[marker.id];
    var keep = Object.create(null), walk = target && target.active ? target : null;
    while (walk) { keep[walk.id] = true; walk = entries[walk.parent]; }
    var active = Object.keys(entries).map(function (id) { return entries[id]; }).filter(function (entry) { return entry.active && !keep[entry.id]; }).sort(function (a,b) { return b.id-a.id; });
    var root = active.length ? active[active.length-1].root : null;
    handling = true;
    try {
      active.forEach(function (entry) { retire(entry, true); });
      // Keep the selected variant URL when closing a layer on this product.
      // Never rewrite a different route reached via real navigation.
      var url = traversal && traversal.url || root && root.url;
      if (url && new URL(url, global.location.href).pathname === global.location.pathname) {
        try { replace(marker, url); } catch (_) {}
      }
      if (marker && (!target || !target.active) && !traversal) {
        try { replace(null); } catch (_) {} // stale forward entry: no reopen/resubmit
      }
    } finally { handling = false; }
    if (traversal) drain();
  }
  function bind(options) {
    var modal = options && options.modal;
    if (!modal || !modal.modal || bindings.has(modal)) return null;
    var binding = { modal:modal, entry:null }, originalClose = modal.close;
    binding.close = function () {
      var result = originalClose.apply(modal, arguments);
      if (!visible(binding) && binding.entry) release(binding.entry);
      return result;
    };
    modal.close = binding.close;
    binding.back = options.onBack;
    bindings.set(modal, binding);
    return { destroy:function () {
      if (modal.close === binding.close) modal.close = originalClose;
      if (binding.entry) release(binding.entry);
      bindings.delete(modal);
    } };
  }
  function reserve(modal, onCancel) {
    var binding = bindings.get(modal);
    if (!binding) return null;
    if (binding.entry && binding.entry.active) return ticket(binding.entry);
    if (pending) return { isActive:function () { return false; }, cancel:function () {} };
    binding.entry = create(null, function () { if (binding.back) binding.back(); }, onCancel);
    return ticket(binding.entry);
  }
  function openLayer(onBack) {
    if (pending) return { isActive:function () { return false; }, cancel:function () {} };
    var marker = mark(state()), parent = marker && entries[marker.id];
    if (!parent || !parent.active) return null;
    return ticket(create(parent, onBack));
  }
  function rememberURL(url) {
    var marker = mark(state()), entry = marker && entries[marker.id];
    if (entry && entry.active) entry.root.url = new URL(url, global.location.href).href;
  }
  function pageshow(event) {
    // Reloads have no live editor/draft session. Do not reconstruct one from a
    // history marker. BFCache retains this module and uses normal reconciliation.
    var marker = state() && state()[key];
    if (marker && marker.page !== page) { try { replace(null); } catch (_) {} }
    else if (event && event.persisted) reconcile({state:state()});
  }
  global.addEventListener('popstate', reconcile);
  global.addEventListener('pageshow', pageshow);
  pageshow();
  global.GIOEditorHistory = { bind:bind, reserve:reserve, openLayer:openLayer, rememberURL:rememberURL };
})(window);
